import request from '@/utils/request';
const basePath = '/open/quotation';
const baseWordPath = '/open/quotationWord';

/**
 * 验证校验码是否可以询价
 */
export function verifyCode(code) {
    return request.Boss.noTip.post(basePath + '/verifyCode', {}, { code })
}

/////获取询价配置信息
export function getConfigInfo(code) {
    return request.Boss.noTip.post(basePath + '/config', {}, { code })
}

/**
 * 获取询价行业配置（从数据库，带缓存）
 * 使用 request.loadGlobal 缓存到页面生命周期
 */
export function getQuotationConfig() {
    return request.loadGlobal('quotationConfig', () => {
        return request.Boss.noTip.get(baseWordPath + '/config', {}).then(res => {
            return res.data || null;
        });
    });
}

/**
 * 初始化询价配置（页面初始化时调用）
 * 从后端获取配置并填充到导出变量中
 * @returns {Promise} 返回配置数据，失败时抛出异常由上层处理
 */
export async function initQuotationConfig() {
    const config = await getQuotationConfig();
    if (!config) {
        throw new Error('获取询价配置失败');
    }

    // 填充配置到导出变量
    forbiddenIndustries = config.forbiddenIndustries || [];
    allowedIndustries = config.allowedIndustries || [];
    saturatedIndustries = config.saturatedIndustries || [];
    localOnlyIndustries = config.localOnlyIndustries || [];
    regionalSaturatedIndustries = config.regionalSaturatedIndustries || {};
    specialIndustries = config.specialIndustries || [];

    return config;
}
export function getCityList(code, province) {
    return request.Boss.noTip.post(basePath + '/city/list', {}, { code, province })
}
/////获取行业子分类列表
export function getSubCategoryList(code, category) {
    return request.Boss.noTip.post(basePath + '/subCategory/list', {}, { code, category })
}

/////获取行业信息（含扩展信息）
export function getIndustryInfo(code, category, subCategory) {
    return request.Boss.noTip.post(basePath + '/industry/info', {}, { code, category, subCategory })
}

/////计算价格
export function mathPriceInfo(postData) {
    return request.Boss.noTip.post(basePath + '/math', postData)
}

/////包含城市的省份模糊搜索
export function searchProvinceIncludeCity(code, keyword) {
    return request.Boss.noTip.post(basePath + '/province/includeCity/search', {}, { code, keyword })
}

/////包含行业子类的行业分类模糊搜索
export function searchCategoryIncludeSubCategory(code, keyword) {
    return request.Boss.noTip.post(basePath + '/category/includeSubCategory/search', {}, { code, keyword })
}

/////词根统计查询
export function wordStat(wordList, province, city) {
    return request.Boss.noTip.post(basePath + '/word/stat', { wordList, province, city });
}

// 词根统计缓存
const wordStatCache = new Map();
// 词根查询数据统计缓存
const wordQueryStatCache = new Map();

/////词根统计查询(带缓存)
export function wordStatWithCache(wordList, category, subCategory, province, city) {
    if (!wordList || !wordList.length) {
        return Promise.resolve([]);
    }

    // 分离已缓存和未缓存的词根
    const cachedResults = new Map();
    const uncachedWords = [];

    const cachePrefix = `${category}-${subCategory}-${province}-${city}-`;
    const dataCachePrefix = `${province}-${city}-`;

    wordList.forEach(word => {
        const cacheKey = cachePrefix + word;
        if (wordStatCache.has(cacheKey)) {
            cachedResults.set(word, wordStatCache.get(cacheKey));
        } else {
            // 先检查关键词状态
            const statusResult = validateKeywordStatus(category, subCategory, province, city, word);
            if (!statusResult.available) {
                // 不可用，直接缓存并返回
                const cacheData = {
                    word,
                    count: 0,
                    similarCount: 0,
                    available: false,
                    description: statusResult.description
                };
                //// 这里涉及到分类和省市，不能缓存，每次动态查
                wordStatCache.set(cacheKey, cacheData);
                cachedResults.set(word, cacheData);
            } else {
                if(wordQueryStatCache.has(dataCachePrefix + word)){
                    cachedResults.set(word, wordQueryStatCache.get(dataCachePrefix + word));
                }else{
                    // 可用，加入待查询列表
                    uncachedWords.push(word);
                }
            }
        }
    });

    // 如果没有未缓存的词根,直接返回缓存结果
    if (!uncachedWords.length) {
        return Promise.resolve(cachedResults);
    }

    // 查询未缓存的词根
    return wordStat(uncachedWords, province, city).then(res => {
        const newData = res.data || [];

        return newData.map(item => {
            const isSaturated = item.count >= 5 || item.similarCount >= 10;
            return {
                word: item.word,
                count: item.count,
                similarCount: item.similarCount || 0,
                available: !isSaturated,
                description: isSaturated ? '已饱和，建议提前咨询渠道售前' : '未饱和'
            };
        });
    }).then(queryData => {
        //查询到的数据加缓存
        queryData.forEach(item => {
            wordQueryStatCache.set(dataCachePrefix + item.word, item);
            cachedResults.set(item.word, item);
        });
        // 去除未查询到的词根
        var queryWordSet = new Set(queryData.map(s=>s.word));
        uncachedWords.forEach(word => {
            if(!queryWordSet.has(word)){
                cachedResults.set(word,{
                    word,
                    count: 0,
                    similarCount: 0,
                    available: true,
                    description: '未饱和'
                });
            }
        });

        return cachedResults;
    });

}

// 直通车价格类型
export const specialOfferPriceType = 1;
// 活动价格类型
export const activityPriceType = 5;

// ===== 以下为从后端数据库获取的配置（带缓存）=====
// 注意：这些变量在首次调用 getQuotationConfig() 后会被填充
// 在询价页面初始化时调用 getQuotationConfig() 即可

// 禁止开拓的行业关键词（从后端获取）
export let forbiddenIndustries = [];
// 同意开拓的行业关键词（从后端获取）
export let allowedIndustries = [];
// 全国范围饱和行业关键词（从后端获取）
export let saturatedIndustries = [];
// 只能做本地客户的行业关键词（从后端获取）
export let localOnlyIndustries = [];
// 区域范围饱和词（从后端获取）
export let regionalSaturatedIndustries = {};
// 特殊行业（从后端获取）
export let specialIndustries = [];

/**
 * 验证关键词状态
 * @param {string} category - 分类
 * @param {string} subCategory - 子分类
 * @param {string} province - 省份
 * @param {string} city - 城市
 * @param {string} word - 词根
 * @returns {Object} {available: boolean, description: string}
 */
export function validateKeywordStatus(category, subCategory, province, city, word) {
  // 检查分类
  const categoryResult = checkKeywordStatus(category, province, city);
  if (!categoryResult.available) {
    return categoryResult;
  }

  // 检查子分类
  if (subCategory) {
    const subCategoryResult = checkKeywordStatus(subCategory, province, city);
    if (!subCategoryResult.available) {
      return subCategoryResult;
    }
  }

  // 检查词根
  if (word) {
    const wordResult = checkKeywordStatus(word, province, city, true);
    if (!wordResult.available) {
      return wordResult;
    }
  }

  return { available: true, description: '' };
}

/**
 * 检查单个关键词状态
 * @param {string} keyword - 关键词
 * @param {string} province - 省份
 * @param {string} city - 城市
 * @param {boolean} isWord - 是否为词根（影响匹配方式）
 * @returns {Object} {available: boolean, description: string}
 */
function checkKeywordStatus(keyword, province, city, isWord = false) {
  if (!keyword) return { available: true, description: '' };

  // 辅助函数：根据是否为词根选择不同的匹配方式
  const isMatch = (target) => {
    if (isWord) {
      // 词根验证：词根中是否包含禁用关键词
      return keyword.includes(target);
    } else {
      //// 分类/子分类验证：禁用关键词是否包含分类
      //return target.includes(keyword);
      //// 因为：禁用词 黄金拍卖 中包含 拍卖（分类），所以判断逻辑改为： 分类中包含禁用词
      return keyword.includes(target);
    }
  };

  // 1. 检查禁止开拓的行业关键词
  const isForbidden = forbiddenIndustries.some(item => isMatch(item));
  const isAllowed = allowedIndustries.some(item => isMatch(item));

  if (isForbidden && !isAllowed) {
    return { available: false, description: '已禁止' };
  }

  // 如果既禁止又允许，则继续下一步

  // 2. 检查全国范围饱和行业
  if (province === '全国') {
    const isSaturated = saturatedIndustries.some(item => isMatch(item));
    if (isSaturated) {
      return { available: false, description: '已饱和，请咨询渠道售前' };
    }
  }

  // 3. 检查区域范围饱和行业
  if (province && province !== '全国') {
    // 检查省份
    if (regionalSaturatedIndustries[province]) {
      const isProvinceSaturated = regionalSaturatedIndustries[province].some(item => isMatch(item));
      if (isProvinceSaturated) {
        return { available: false, description: '已饱和，请咨询渠道售前' };
      }
    }

    // 检查城市
    if (city && regionalSaturatedIndustries[city]) {
      const isCitySaturated = regionalSaturatedIndustries[city].some(item => isMatch(item));
      if (isCitySaturated) {
        return { available: false, description: '已饱和，请咨询渠道售前' };
      }
    }
  }

  // 4. 如果是全国范围，检查只能做本地的行业
  if (province === '全国') {
    const isLocalOnly = localOnlyIndustries.some(item => isMatch(item));
    if (isLocalOnly) {
      return { available: false, description: '已饱和，请咨询渠道售前' };
    }
  }

  // 5. 检查特殊行业
  const isSpecial = specialIndustries.some(item => isMatch(item));
  if (isSpecial) {
    //console.log('specialIndustries', specialIndustries);
    return { available: false, description: '特殊行业请咨询渠道售前' };
  }

  return { available: true, description: '' };
}

// 分享页面相关API
const baseSharePath = '/open/sdSharePage';

/**
 * 创建询价分享页
 */
export function createQuotationShare(postData) {
    return request.Boss.noTip.post(baseSharePath + '/create', postData)
}

/**
 * 查询询价分享详情
 */
export function getQuotationShareDetail(code) {
    return request.Boss.noTip.get(baseSharePath + '/detail', { code })
}
